import Day from "./DayWeather.js";

function Weekly() {
  return (
    <div className="weather-forecast">
      <Day />
    </div>
  );
}

export default Weekly;
